<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-plant :disabled="isPlant" type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-select
            type="search"
            :comboItems="parentItems"
            itemText="checkItemName"
            itemValue="ramChecklistCheckItemId"
            name="parentChecklistCheckItemId"
            label="대분류"
            v-model="searchParam.parentChecklistCheckItemId"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="평가대상 목록"
      rowKey="ramChecklistCheckItemId"
      :selection="popupParam.type"
      :merge="grid.merge"
      :gridHeight="grid.height"
      :columns="grid.columns"
      :data="grid.data"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
      <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'checklist-master-pop',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        type: "multiple",
        plantCd: '',
      }),
    },
    // contentHeight: {
    //   type: [String, Number],
    //   default: function () {
    //     return "auto";
    //   },
    // },
  },
  data() {
    return {
      searchParam: {
        plantCd: '',
        useFlag: 'Y',
        parentChecklistCheckItemId: null,
      },
      grid: {
        merge: [
          { index: 0, colName: 'mergeGroup' },
        ],
        columns: [
          // {
          //   name: 'plantName',
          //   field: 'plantName',
          //   label: '공사현장',
          //   align: 'center',
          //   style: 'width:200px',
          //   sortable: true,
          // },
          {
            name: 'parentCheckItemName',
            field: 'parentCheckItemName',
            label: '대분류',
            align: 'center',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'checkItemName',
            field: 'checkItemName',
            label: '중분류',
            align: 'center',
            sortable: true,
            style: 'width:300px',
          },
        ],
        data: [],
        height: "700px",
      },
      editable: true,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      listUrl: '',
      searchUrl: '',
      isPlant: false,
      childEditable: false,
      popupData: {
        first: '',
        type : null,
        plantCd: '',
      },
      parentItems: [],
      parentListUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  watch: {
    // contentHeight() {
    //   let height =
    //     this.contentHeight - this.$refs["searchbox"].$el.offsetHeight - 50;
    //   if (height < 400) {
    //     height = 500;
    //   }

    //   this.grid.height = height + "px";
    // },
  },
  methods: {
    init() {
      // role setting
      // url setting
      this.listUrl = selectConfig.ram.checklist.master.list.pop.url;
      this.parentListUrl = selectConfig.ram.checklist.master.list.url;

      if (this.popupParam.plantCd) {
        this.searchParam.plantCd = this.popupParam.plantCd
        this.isPlant = true;
      }
      // code setting
      this.parentUrl();
      this.getList();
    },
    parentUrl() {
      this.$http.url = this.parentListUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.searchParam.plantCd,
        useFlag: 'Y',
        checklistLevelCd: '1'
      };
      this.$http.request((_result) => {
        if (_result.data && _result.data.length > 0) {
          this.$_.forEach(_result.data, _item => {
            this.parentItems.splice(0, 0, {
              ramChecklistCheckItemId: _item.ramChecklistCheckItemId,
              checkItemName: _item.checkItemName,
            })
          })
        }
      },);
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "평가대상을 선택하세요.", // 평가대상을 선택하세요.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
  }
};
</script>
